import BigNumber from 'bignumber.js';

import {
  getExtendedErrorText,
  mainApi,
  queryFnNotifyWrapper,
} from 'modules/api';
import { withProvider } from 'modules/auth';
import { currentEnv } from 'modules/common';

import { getStakeGasEstimation } from '../api/getStakeGasEstimation';

type Args = {
  amount: BigNumber.Value;
};

interface IResult {
  estimatedGas: BigNumber;
}

export const { useLazyGetStakeGasEstimationQuery } = mainApi.injectEndpoints({
  endpoints: build => ({
    getStakeGasEstimation: build.query<IResult, Args>({
      queryFn: queryFnNotifyWrapper<Args, never, IResult>(
        async args =>
          withProvider({
            args,
            call: async ({ provider, amount }) => {
              const data = await getStakeGasEstimation({
                walletAccount: provider.getWalletAccount(),
                client: provider.getClient(),
                amount: new BigNumber(amount),
                env: currentEnv,
              });

              return { data };
            },
          }),
        error => getExtendedErrorText(error, 'Failed to estimate gas'),
      ),
    }),
  }),
});
